import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ai.review');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { workflowStatusCssClass, workflowStatusLabel, workflowStatus } from '../shared/workflow-status';

@Component({
    selector: 'wiz-page-ai-review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ai.review/view.scss */
:host {
  display: block;
  height: 100%;
}

.ops-ai-workbench {
  padding: 16px 18px 26px;
}

.ops-review-inner {
  display: grid;
  max-width: none;
  gap: 12px;
}

.ops-review-commandbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  min-height: 76px;
  border: 1px solid var(--ops-panel-border);
  border-radius: var(--ops-radius);
  background: rgba(255, 255, 255, 0.92);
  box-shadow: var(--ops-shadow);
  padding: 15px 18px;
}

.review-command-title {
  min-width: 0;
}

.review-command-title h1 {
  margin-top: 6px;
  overflow: hidden;
  color: var(--ops-heading);
  font-size: 25px;
  font-weight: 900;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-command-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.review-workbench-grid {
  display: grid;
  grid-template-columns: 232px minmax(0, 1fr) 304px;
  gap: 12px;
  align-items: start;
}

.candidate-queue,
.decision-dock,
.comparison-workbench {
  border: 1px solid var(--ops-panel-border);
  border-radius: var(--ops-radius);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: var(--ops-shadow);
}

.candidate-queue,
.decision-dock {
  position: sticky;
  top: 12px;
  display: flex;
  max-height: calc(100vh - 100px);
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
}

.candidate-queue {
  padding: 10px;
}

.queue-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 8px;
}

.queue-head h2,
.viewer-title h2,
.decision-core h2 {
  margin-top: 5px;
  color: var(--ops-heading);
  font-size: 17px;
  font-weight: 900;
  line-height: 1.25;
}

.queue-count {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  border-radius: 999px;
  background: var(--ops-primary-dark);
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
  padding: 0 10px;
  white-space: nowrap;
}

.queue-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  padding-bottom: 8px;
}

.queue-metric {
  min-width: 0;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-muted);
  padding: 8px;
}

.queue-metric span,
.queue-metric strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.queue-metric span {
  color: var(--ops-muted);
  font-size: 10px;
  font-weight: 900;
}

.queue-metric strong {
  margin-top: 5px;
  color: var(--ops-heading);
  font-size: 16px;
  font-weight: 900;
}

.queue-metric.is-waiting {
  border-color: var(--ops-info-border);
  background: var(--ops-info-soft);
}

.queue-metric.is-recapture {
  border-color: var(--ops-warning-border);
  background: var(--ops-warning-soft);
}

.queue-metric.is-field-check {
  border-color: var(--ops-danger-border);
  background: var(--ops-danger-soft);
}

.queue-metric.is-complete {
  border-color: var(--ops-success-border);
  background: var(--ops-success-soft);
}

.candidate-list {
  display: grid;
  min-height: 0;
  gap: 6px;
  overflow-y: auto;
  padding-right: 2px;
}

.candidate-row {
  display: grid;
  grid-template-columns: minmax(78px, auto) minmax(0, 1fr);
  gap: 6px 8px;
  align-items: center;
  min-height: 74px;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: #ffffff;
  padding: 8px;
  text-align: left;
  transition: background-color 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
}

.candidate-row:hover {
  border-color: var(--ops-border-strong);
  background: var(--ops-surface-muted);
}

.candidate-row.is-selected {
  border-color: #111714;
  background: #f3f7f4;
  box-shadow: inset 3px 0 0 #111714;
}

.candidate-guidance {
  display: inline-flex;
  min-width: 74px;
  min-height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ops-border);
  border-radius: 999px;
  padding: 0 9px;
  font-size: 10px;
  font-weight: 900;
  line-height: 1.15;
  text-align: center;
  white-space: normal;
  word-break: keep-all;
}

.candidate-copy {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.candidate-copy strong,
.candidate-copy em,
.candidate-copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.candidate-copy strong {
  color: var(--ops-heading);
  font-size: 13px;
  font-weight: 900;
}

.candidate-copy em,
.candidate-copy small {
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  line-height: 1.3;
}

.status-pill {
  grid-column: 2;
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  min-height: 22px;
  align-items: center;
  border: 1px solid var(--ops-border);
  border-radius: 999px;
  padding: 0 8px;
  color: var(--ops-muted-strong);
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
  white-space: nowrap;
}

.is-guidance-field,
.status-pill.is-status-field,
.guidance-pill.is-guidance-field {
  border-color: var(--ops-danger-border);
  background: var(--ops-danger-soft);
  color: var(--ops-danger);
}

.is-guidance-recheck,
.status-pill.is-status-recapture,
.guidance-pill.is-guidance-recheck {
  border-color: var(--ops-warning-border);
  background: var(--ops-warning-soft);
  color: var(--ops-warning);
}

.is-guidance-review,
.status-pill.is-status-review,
.guidance-pill.is-guidance-review {
  border-color: var(--ops-info-border);
  background: var(--ops-info-soft);
  color: var(--ops-info);
}

.is-guidance-report,
.status-pill.is-status-closed,
.guidance-pill.is-guidance-report {
  border-color: var(--ops-success-border);
  background: var(--ops-success-soft);
  color: var(--ops-success);
}

.is-guidance-clear,
.status-pill.is-status-false,
.status-pill.is-status-neutral,
.guidance-pill.is-guidance-clear {
  border-color: var(--ops-neutral-border);
  background: var(--ops-neutral-soft);
  color: var(--ops-neutral);
}

.status-pill.is-work-patrol-setup-required,
.guidance-pill.is-work-patrol-setup-required,
.candidate-guidance.is-work-patrol-setup-required,
.run-guidance.is-work-patrol-setup-required,
.queue-metric.is-work-patrol-setup-required,
.status-pill.is-work-recapture-requested,
.guidance-pill.is-work-recapture-requested,
.candidate-guidance.is-work-recapture-requested,
.run-guidance.is-work-recapture-requested,
.queue-metric.is-work-recapture-requested {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.status-pill.is-work-patrol-scheduled,
.guidance-pill.is-work-patrol-scheduled,
.candidate-guidance.is-work-patrol-scheduled,
.run-guidance.is-work-patrol-scheduled,
.queue-metric.is-work-patrol-scheduled {
  border-color: #d4d8d5;
  background: #f7faf8;
  color: #46534c;
}

.status-pill.is-work-patrol-running,
.guidance-pill.is-work-patrol-running,
.candidate-guidance.is-work-patrol-running,
.run-guidance.is-work-patrol-running,
.queue-metric.is-work-patrol-running {
  border-color: #bae6fd;
  background: #f0f9ff;
  color: #0369a1;
}

.status-pill.is-work-patrol-completed,
.guidance-pill.is-work-patrol-completed,
.candidate-guidance.is-work-patrol-completed,
.run-guidance.is-work-patrol-completed,
.queue-metric.is-work-patrol-completed {
  border-color: #99f6e4;
  background: #f0fdfa;
  color: #0f766e;
}

.status-pill.is-work-ai-required,
.guidance-pill.is-work-ai-required,
.candidate-guidance.is-work-ai-required,
.run-guidance.is-work-ai-required,
.queue-metric.is-work-ai-required {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}

.status-pill.is-work-field-check-required,
.guidance-pill.is-work-field-check-required,
.candidate-guidance.is-work-field-check-required,
.run-guidance.is-work-field-check-required,
.queue-metric.is-work-field-check-required {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.status-pill.is-work-report-required,
.guidance-pill.is-work-report-required,
.candidate-guidance.is-work-report-required,
.run-guidance.is-work-report-required,
.queue-metric.is-work-report-required {
  border-color: #a5f3fc;
  background: #ecfeff;
  color: #0e7490;
}

.status-pill.is-work-report-generated,
.guidance-pill.is-work-report-generated,
.candidate-guidance.is-work-report-generated,
.run-guidance.is-work-report-generated,
.queue-metric.is-work-report-generated {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.comparison-workbench {
  display: grid;
  min-width: 0;
  gap: 10px;
  border-color: var(--ops-border-strong);
  box-shadow: var(--ops-shadow-strong);
  padding: 10px;
}

.viewer-toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: 10px;
}

.viewer-title {
  min-width: 0;
}

.viewer-title h2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.viewer-meta-strip,
.viewer-status-strip {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.viewer-meta-strip span,
.viewer-status-strip span,
.viewer-status-strip strong,
.guidance-pill {
  display: inline-flex;
  min-height: 26px;
  max-width: 100%;
  align-items: center;
  border: 1px solid var(--ops-border);
  border-radius: 999px;
  background: var(--ops-surface-muted);
  color: var(--ops-muted-strong);
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
  padding: 0 9px;
  white-space: nowrap;
}

.viewer-status-strip {
  justify-content: flex-start;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-muted);
  padding: 8px;
}

.viewer-status-strip strong {
  border-color: var(--ops-primary-dark);
  background: var(--ops-primary-dark);
  color: #ffffff;
}

.comparison-viewer {
  display: grid;
  grid-template-columns: minmax(0, 0.88fr) minmax(0, 1.12fr);
  gap: 9px;
  border: 1px solid #25312d;
  border-radius: var(--ops-radius);
  background: #121a17;
  box-shadow: var(--ops-shadow-strong);
  padding: 9px;
}

.viewer-pane {
  display: grid;
  grid-template-rows: auto 1fr;
  min-width: 0;
  overflow: hidden;
  margin: 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: var(--ops-radius-sm);
  background: #0e1412;
}

.viewer-pane figcaption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 36px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.88);
  padding: 0 10px;
}

.viewer-pane figcaption span,
.viewer-pane figcaption strong {
  overflow: hidden;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.viewer-pane figcaption span {
  color: rgba(255, 255, 255, 0.58);
}

.viewer-pane .ai-review-photo {
  height: min(62vh, 580px);
  min-height: 460px;
  border-radius: 0;
}

.review-support-drawer,
.decision-support-drawer {
  overflow: hidden;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: #ffffff;
}

.review-support-drawer summary,
.decision-support-drawer summary {
  display: flex;
  min-height: 40px;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: var(--ops-surface-muted);
  padding: 0 12px;
  list-style: none;
}

.review-support-drawer summary::-webkit-details-marker,
.decision-support-drawer summary::-webkit-details-marker {
  display: none;
}

.review-support-drawer summary span,
.decision-support-drawer summary span {
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 900;
}

.review-support-drawer summary strong,
.decision-support-drawer summary strong {
  overflow: hidden;
  color: var(--ops-heading);
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.support-grid {
  display: grid;
  grid-template-columns: 0.7fr 1.1fr 1fr 1fr;
  gap: 8px;
  border-top: 1px solid var(--ops-border);
  padding: 10px;
}

.support-block {
  min-width: 0;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-muted);
  padding: 8px;
}

.support-block p {
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 900;
}

.support-block > strong,
.support-block > span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.support-block > strong {
  margin-top: 6px;
  color: var(--ops-heading);
  font-size: 13px;
  font-weight: 900;
  line-height: 1.35;
  white-space: nowrap;
}

.support-block > span {
  margin-top: 5px;
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 800;
  line-height: 1.45;
  white-space: normal;
}

.support-rows {
  display: grid;
  gap: 7px;
  margin-top: 8px;
}

.support-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  border: 1px solid var(--ops-border-subtle);
  border-radius: var(--ops-radius-xs);
  background: #ffffff;
  padding: 8px;
}

.support-row span {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.support-row strong,
.support-row em,
.support-row small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.support-row strong {
  color: var(--ops-heading);
  font-size: 12px;
  font-weight: 900;
}

.support-row em,
.support-row small {
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.decision-dock {
  gap: 10px;
  padding: 10px;
}

.decision-core {
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-muted);
  padding: 12px;
}

.decision-core span {
  display: block;
  margin-top: 6px;
  color: var(--ops-muted);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.45;
}

.primary-decision-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.decision-action {
  display: grid;
  min-height: 92px;
  align-content: center;
  gap: 6px;
  border: 1px solid transparent;
  border-radius: var(--ops-radius-sm);
  padding: 13px 12px;
  text-align: left;
  transition: border-color 140ms ease, box-shadow 140ms ease, transform 140ms ease, filter 140ms ease;
}

.decision-action:hover {
  filter: brightness(0.97);
}

.decision-action:focus-visible,
.decision-next button:focus-visible,
.candidate-row:focus-visible {
  outline: 2px solid var(--ops-info);
  outline-offset: 2px;
}

.decision-action strong {
  font-size: 16px;
  font-weight: 900;
  line-height: 1.15;
}

.decision-action span {
  font-size: 11px;
  font-weight: 900;
  line-height: 1.35;
}

.decision-action.is-false-positive {
  border-color: #151a18;
  background: #151a18;
  color: #ffffff;
}

.decision-action.is-recapture {
  border-color: #d3a339;
  background: #f5d77c;
  color: #3d2c09;
}

.decision-action.is-field-check {
  border-color: #b44a5c;
  background: #b7364d;
  color: #ffffff;
}

.decision-action.is-closed {
  border-color: #176a43;
  background: #1f7a4d;
  color: #ffffff;
}

.decision-action.is-active {
  box-shadow: 0 0 0 3px #ffffff, 0 0 0 6px rgba(31, 95, 139, 0.22), 0 12px 24px rgba(17, 24, 39, 0.14);
  transform: translateY(-1px);
}

.decision-memo {
  display: grid;
  gap: 7px;
}

.decision-memo span {
  color: var(--ops-muted-strong);
  font-size: 12px;
  font-weight: 900;
}

.decision-memo textarea {
  min-height: 92px;
  border: 1px solid var(--ops-border-strong);
  border-radius: var(--ops-radius-sm);
  background: #ffffff;
  color: var(--ops-text);
  padding: 10px;
  resize: vertical;
}

.decision-next {
  display: grid;
  gap: 8px;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-muted);
  padding: 10px;
}

.decision-next strong,
.decision-next span {
  font-size: 12px;
  font-weight: 900;
  line-height: 1.35;
}

.decision-next span {
  color: var(--ops-muted);
}

.decision-definition-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  border-top: 1px solid var(--ops-border);
  margin: 0;
  padding: 12px;
}

.decision-definition-list > div {
  min-width: 0;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-muted);
  padding: 9px;
}

.decision-definition-list dt,
.decision-definition-list dd {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.decision-definition-list dt {
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 900;
}

.decision-definition-list dd {
  margin: 5px 0 0;
  color: var(--ops-heading);
  font-size: 13px;
  font-weight: 900;
}

.candidate-list::-webkit-scrollbar,
.candidate-queue::-webkit-scrollbar,
.decision-dock::-webkit-scrollbar {
  width: 6px;
}

.candidate-list::-webkit-scrollbar-thumb,
.candidate-queue::-webkit-scrollbar-thumb,
.decision-dock::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(82, 91, 85, 0.32);
}

.ai-review-photo {
  position: relative;
  overflow: hidden;
  background: #d4dfcc;
  box-shadow: inset 0 0 0 1px rgba(24, 39, 34, 0.08), inset 0 -40px 80px rgba(27, 38, 28, 0.12);
}

.ai-review-photo::before,
.ai-review-photo::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.ai-review-photo::before {
  z-index: 2;
  background: linear-gradient(90deg, transparent calc(50% - 1px), rgba(255, 255, 255, 0.28) 50%, transparent calc(50% + 1px)), linear-gradient(0deg, transparent calc(50% - 1px), rgba(255, 255, 255, 0.22) 50%, transparent calc(50% + 1px)), radial-gradient(circle at 50% 50%, transparent 0 42%, rgba(17, 24, 39, 0.08) 100%);
}

.ai-review-photo::after {
  z-index: 3;
  background-image: linear-gradient(rgba(255, 255, 255, 0.16) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.14) 1px, transparent 1px);
  background-size: 52px 52px;
  opacity: 0.55;
}

.drone-terrain,
.feature,
.drone-noise,
.candidate-box,
.drone-hud {
  position: absolute;
}

.drone-terrain {
  inset: 0;
}

.drone-noise {
  inset: -20%;
  z-index: 1;
  opacity: 0.28;
  background: radial-gradient(circle at 18% 24%, rgba(255, 255, 255, 0.35) 0 1px, transparent 2px), radial-gradient(circle at 74% 36%, rgba(44, 71, 54, 0.16) 0 1px, transparent 3px), radial-gradient(circle at 42% 82%, rgba(39, 52, 44, 0.12) 0 1px, transparent 3px);
  background-size: 18px 18px, 26px 26px, 22px 22px;
}

.feature {
  z-index: 1;
}

.terrain-saneri {
  background: radial-gradient(circle at 74% 12%, rgba(120, 150, 104, 0.5), transparent 24%), linear-gradient(120deg, #9cb990 0%, #c9d6bd 34%, #d9c6a2 35%, #d9c6a2 62%, #b6c6b0 63%, #dfe7d7 100%);
}

.terrain-samgari {
  background: linear-gradient(90deg, rgba(133, 159, 92, 0.28), transparent 30%, rgba(213, 195, 119, 0.28) 70%), linear-gradient(135deg, #b8c982 0%, #d0bc77 34%, #94b877 35%, #c9d49a 100%);
}

.terrain-beopjusa {
  background: radial-gradient(circle at 12% 20%, rgba(67, 103, 72, 0.55), transparent 31%), linear-gradient(135deg, #829e76 0%, #a9ba9c 32%, #b9b4a8 33%, #c6c1b7 62%, #dfd4c0 63%, #c9d5bc 100%);
}

.ai-review-photo:not(.terrain-saneri) .saneri-feature,
.ai-review-photo:not(.terrain-samgari) .samgari-feature,
.ai-review-photo:not(.terrain-beopjusa) .beopjusa-feature {
  display: none;
}

.change-feature {
  opacity: 0;
  transition: opacity 0.18s ease;
}

.is-current .change-feature {
  opacity: 1;
}

.saneri-river {
  left: -8%;
  top: -14%;
  width: 35%;
  height: 128%;
  border-radius: 48%;
  transform: rotate(21deg);
  background: linear-gradient(90deg, rgba(47, 117, 137, 0.86), rgba(89, 155, 162, 0.9), rgba(186, 211, 199, 0.65));
  box-shadow: 0 0 0 8px rgba(222, 214, 169, 0.28), inset -12px 0 22px rgba(255, 255, 255, 0.24);
}

.saneri-bank {
  left: 22%;
  top: -8%;
  width: 11%;
  height: 118%;
  border-radius: 45%;
  transform: rotate(19deg);
  background: rgba(212, 196, 142, 0.48);
}

.saneri-road {
  height: 8%;
  border-radius: 999px;
  background: linear-gradient(180deg, #a79c8d, #d7d0bf 48%, #8e877b);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.46), 0 0 0 3px rgba(97, 89, 73, 0.08);
}

.saneri-road-main {
  left: 27%;
  top: 58%;
  width: 72%;
  transform: rotate(-12deg);
}

.saneri-road-side {
  left: 43%;
  top: 22%;
  width: 45%;
  transform: rotate(34deg);
}

.roof {
  border-radius: 3px;
  background: linear-gradient(135deg, #b84f3e 0%, #d9956d 48%, #853b35 49%, #b56750 100%);
  border: 1px solid rgba(92, 53, 42, 0.36);
  box-shadow: 0 3px 8px rgba(40, 34, 25, 0.18);
}

.roof::after {
  content: "";
  position: absolute;
  left: 8%;
  right: 8%;
  top: 45%;
  height: 1px;
  background: rgba(255, 255, 255, 0.46);
}

.roof-1 {
  left: 48%;
  top: 27%;
  width: 17%;
  height: 10%;
  transform: rotate(20deg);
}

.roof-2 {
  left: 61%;
  top: 38%;
  width: 18%;
  height: 9%;
  transform: rotate(20deg);
}

.roof-3 {
  left: 39%;
  top: 39%;
  width: 13%;
  height: 8%;
  transform: rotate(17deg);
}

.roof-4 {
  left: 70%;
  top: 20%;
  width: 12%;
  height: 8%;
  transform: rotate(24deg);
}

.tree-line {
  border-radius: 999px;
  background: radial-gradient(circle, #4f7749 0 35%, #739663 36% 62%, transparent 64%);
  background-size: 16px 16px;
}

.tree-line-1 {
  left: 76%;
  top: 52%;
  width: 24%;
  height: 18%;
  transform: rotate(-14deg);
}

.tree-line-2 {
  left: 31%;
  top: 71%;
  width: 48%;
  height: 15%;
  transform: rotate(5deg);
}

.saneri-roof-change {
  left: 63%;
  top: 30%;
  width: 15%;
  height: 8%;
  border-radius: 3px;
  transform: rotate(20deg);
  background: linear-gradient(135deg, #d99b3d, #f0d48c);
  border: 1px solid rgba(146, 89, 20, 0.55);
  box-shadow: 0 0 0 2px rgba(255, 247, 237, 0.55), 0 5px 10px rgba(84, 55, 19, 0.2);
}

.field {
  border: 1px solid rgba(89, 99, 61, 0.18);
  border-radius: 4px;
  background: repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.18) 0 3px, transparent 3px 11px), linear-gradient(135deg, #9fbe76, #d6ca8b);
  box-shadow: inset 0 0 18px rgba(83, 92, 50, 0.14);
}

.field-1 {
  left: -6%;
  top: -6%;
  width: 49%;
  height: 58%;
  transform: rotate(-10deg);
}

.field-2 {
  left: 39%;
  top: -5%;
  width: 39%;
  height: 48%;
  transform: rotate(-10deg);
  background: repeating-linear-gradient(90deg, rgba(54, 85, 45, 0.14) 0 2px, transparent 2px 12px), linear-gradient(135deg, #7daa64, #bdd17d);
}

.field-3 {
  left: 12%;
  top: 48%;
  width: 44%;
  height: 54%;
  transform: rotate(-10deg);
  background: repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.16) 0 2px, transparent 2px 10px), linear-gradient(135deg, #d5c17b, #b9ce8a);
}

.field-4 {
  left: 56%;
  top: 42%;
  width: 49%;
  height: 52%;
  transform: rotate(-10deg);
  background: repeating-linear-gradient(90deg, rgba(74, 82, 43, 0.16) 0 2px, transparent 2px 9px), linear-gradient(135deg, #cfb66e, #dfd09a);
}

.farm-road {
  height: 7%;
  border-radius: 999px;
  background: linear-gradient(180deg, #b6a478, #e5d9ad 55%, #a08f67);
  box-shadow: 0 0 0 3px rgba(78, 68, 45, 0.08);
}

.farm-road-1 {
  left: -4%;
  top: 41%;
  width: 112%;
  transform: rotate(-10deg);
}

.farm-road-2 {
  left: 45%;
  top: -6%;
  width: 7%;
  height: 110%;
  transform: rotate(-10deg);
}

.greenhouse {
  height: 5%;
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.82), rgba(210, 227, 217, 0.74));
  border: 1px solid rgba(132, 143, 126, 0.32);
  box-shadow: 0 2px 7px rgba(76, 83, 64, 0.14);
}

.greenhouse-1 {
  left: 18%;
  top: 58%;
  width: 22%;
  transform: rotate(-10deg);
}

.greenhouse-2 {
  left: 62%;
  top: 26%;
  width: 18%;
  transform: rotate(-10deg);
}

.samgari-shelter-change {
  left: 42%;
  top: 46%;
  width: 27%;
  height: 9%;
  border-radius: 999px;
  transform: rotate(-10deg);
  background: repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.9) 0 6px, rgba(191, 210, 205, 0.85) 6px 12px), linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(210, 231, 226, 0.9));
  border: 1px solid rgba(104, 118, 115, 0.42);
  box-shadow: 0 0 0 2px rgba(255, 251, 235, 0.7), 0 5px 12px rgba(76, 83, 64, 0.18);
}

.forest-edge {
  border-radius: 999px;
  background: radial-gradient(circle, #315f3e 0 33%, #5f8a51 34% 62%, transparent 64%);
  background-size: 18px 18px;
}

.forest-edge-1 {
  left: -8%;
  top: -8%;
  width: 48%;
  height: 54%;
  transform: rotate(18deg);
}

.forest-edge-2 {
  left: 72%;
  top: -5%;
  width: 36%;
  height: 112%;
  transform: rotate(6deg);
}

.entry-road {
  border-radius: 999px;
  background: linear-gradient(180deg, #8d8a82, #d2ccc0 48%, #76736d);
  box-shadow: 0 0 0 5px rgba(72, 69, 64, 0.1);
}

.entry-road-main {
  left: -8%;
  top: 47%;
  width: 116%;
  height: 12%;
  transform: rotate(15deg);
}

.entry-road-branch {
  left: 38%;
  top: 15%;
  width: 15%;
  height: 67%;
  transform: rotate(-28deg);
}

.paved-yard {
  left: 38%;
  top: 48%;
  width: 36%;
  height: 31%;
  border-radius: 10px;
  transform: rotate(14deg);
  background: repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.14) 0 2px, transparent 2px 18px), linear-gradient(135deg, #b7afa2, #d0c6b7);
  border: 1px solid rgba(87, 80, 70, 0.22);
}

.building {
  border-radius: 4px;
  background: linear-gradient(135deg, #a75846, #cf9271);
  border: 1px solid rgba(86, 56, 45, 0.34);
  box-shadow: 0 3px 8px rgba(45, 38, 30, 0.16);
}

.building-1 {
  left: 24%;
  top: 32%;
  width: 13%;
  height: 10%;
  transform: rotate(14deg);
}

.building-2 {
  left: 62%;
  top: 29%;
  width: 12%;
  height: 9%;
  transform: rotate(14deg);
}

.beopjusa-stack-change {
  left: 50%;
  top: 57%;
  width: 15%;
  height: 14%;
  border-radius: 5px;
  transform: rotate(14deg);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.28) 1px, transparent 1px), linear-gradient(0deg, rgba(255, 255, 255, 0.22) 1px, transparent 1px), linear-gradient(135deg, #80624b, #c28c55);
  background-size: 12px 12px, 12px 12px, auto;
  border: 1px solid rgba(79, 53, 34, 0.58);
  box-shadow: 0 0 0 2px rgba(255, 247, 237, 0.58), 0 5px 12px rgba(45, 38, 30, 0.22);
}

.drone-hud {
  left: 10px;
  right: 10px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-radius: 4px;
  background: rgba(17, 24, 39, 0.66);
  padding: 6px 8px;
  color: #f8fafc;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0;
}

.drone-hud-top {
  top: 10px;
}

.drone-hud-bottom {
  bottom: 10px;
}

.drone-hud span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.candidate-box {
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 64px;
  min-height: 42px;
  border-radius: 4px;
  border: 2px solid rgba(167, 53, 71, 0.95);
  background: rgba(251, 237, 240, 0.2);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.82), 0 0 18px rgba(167, 53, 71, 0.24);
}

.candidate-title {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  max-width: 160px;
  border-radius: 4px;
  background: rgba(121, 39, 51, 0.96);
  padding: 5px 7px;
  color: #ffffff;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.25;
  text-align: left;
  word-break: keep-all;
}

.candidate-state-labels {
  position: absolute;
  top: 50%;
  left: calc(100% + 9px);
  display: flex;
  width: 128px;
  transform: translateY(-50%);
  flex-direction: column;
  gap: 4px;
}

.candidate-label-left .candidate-state-labels {
  right: calc(100% + 9px);
  left: auto;
}

.candidate-label-above .candidate-state-labels {
  top: auto;
  bottom: calc(100% + 7px);
  left: 0;
  transform: none;
}

.candidate-state-labels::before {
  content: "";
  position: absolute;
  top: 50%;
  left: -10px;
  width: 10px;
  height: 2px;
  transform: translateY(-50%);
  background: rgba(167, 53, 71, 0.9);
}

.candidate-label-left .candidate-state-labels::before {
  right: -10px;
  left: auto;
}

.candidate-state-labels span {
  border-radius: 4px;
  border: 1px solid var(--ops-danger-border);
  background: rgba(255, 255, 255, 0.94);
  padding: 4px 6px;
  color: var(--ops-danger);
  font-size: 10px;
  font-weight: 900;
  line-height: 1.2;
  box-shadow: 0 2px 8px rgba(24, 24, 27, 0.12);
  word-break: keep-all;
}

.candidate-state-labels span:nth-child(2) {
  border-color: var(--ops-warning-border);
  color: var(--ops-warning);
}

@media (max-width: 1279px) {
  .review-workbench-grid {
    grid-template-columns: 1fr;
  }
  .candidate-queue,
  .decision-dock {
    position: static;
    max-height: none;
  }
  .candidate-list {
    max-height: 260px;
  }
  .support-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 900px) {
  .ops-review-commandbar,
  .viewer-toolbar,
  .comparison-viewer,
  .support-grid,
  .decision-definition-list {
    grid-template-columns: 1fr;
  }
  .review-command-actions,
  .viewer-meta-strip {
    justify-content: flex-start;
  }
  .viewer-pane .ai-review-photo {
    height: 430px;
    min-height: 360px;
  }
}
@media (max-width: 639px) {
  .ops-ai-workbench {
    padding: 12px;
  }
  .primary-decision-actions,
  .queue-metrics {
    grid-template-columns: 1fr;
  }
  .viewer-pane .ai-review-photo {
    height: 340px;
    min-height: 300px;
  }
  .drone-hud {
    align-items: flex-start;
    flex-direction: column;
  }
  .candidate-title {
    max-width: min(150px, 100vw - 88px);
    font-size: 10px;
  }
  .candidate-state-labels,
  .candidate-label-left .candidate-state-labels,
  .candidate-label-above .candidate-state-labels {
    top: calc(100% + 7px);
    right: auto;
    bottom: auto;
    left: 0;
    width: min(150px, 100vw - 88px);
    transform: none;
  }
  .candidate-state-labels::before {
    display: none;
  }
}
@media (max-width: 479px) {
  .candidate-state-labels {
    display: none;
  }
}
.ai-theater-shell {
  min-height: 100%;
  padding: 16px 18px 26px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.74), rgba(255, 255, 255, 0) 220px), #edf2f0;
  color: var(--ops-text);
  word-break: keep-all;
}

.ai-theater-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 8px;
}

.ai-review-list-screen {
  display: grid;
  gap: 0;
  min-height: calc(100vh - 114px);
  overflow: hidden;
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
}

.ai-review-list-head {
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--ops-border-strong);
  background: linear-gradient(90deg, rgba(15, 21, 18, 0.035) 1px, transparent 1px), #ffffff;
  background-size: 26px 26px;
  padding: 0 18px;
}

.ai-review-list-head h1 {
  margin-top: 5px;
  color: var(--ops-heading);
  font-size: 22px;
  font-weight: 900;
  line-height: 1.2;
}

.ai-review-list-head > span {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  border-radius: 999px;
  background: var(--ops-primary-dark);
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  padding: 0 12px;
  white-space: nowrap;
}

.ai-review-run-list {
  display: grid;
  align-content: start;
  overflow-y: auto;
}

.ai-review-run-row {
  display: grid;
  grid-template-columns: minmax(90px, auto) minmax(0, 1fr) minmax(92px, auto);
  align-items: center;
  gap: 12px;
  min-height: 76px;
  border: 0;
  border-bottom: 1px solid var(--ops-border);
  background: #ffffff;
  padding: 12px 18px;
  text-align: left;
  transition: background-color 140ms ease, box-shadow 140ms ease;
}

.ai-review-run-row:hover {
  background: #f6f8f7;
  box-shadow: inset 4px 0 0 #111714;
}

.run-guidance {
  display: inline-flex;
  min-width: 86px;
  min-height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ops-border);
  border-radius: 999px;
  padding: 0 10px;
  font-size: 11px;
  font-weight: 900;
  line-height: 1.15;
  text-align: center;
  white-space: normal;
  word-break: keep-all;
}

.run-copy,
.run-meta {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.run-copy strong,
.run-copy em,
.run-meta strong,
.run-meta em {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.run-copy strong {
  color: var(--ops-heading);
  font-size: 15px;
  font-weight: 900;
}

.run-copy em,
.run-meta em {
  color: var(--ops-muted);
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
}

.run-meta {
  justify-items: end;
}

.run-meta strong {
  color: var(--ops-heading);
  font-size: 14px;
  font-weight: 900;
}

.ai-theater-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 268px;
  gap: 0;
  height: calc(100vh - 114px);
  min-height: 620px;
  margin-top: 0;
  overflow: hidden;
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
}

.ai-comparison-deck {
  display: flex;
  min-width: 0;
  min-height: 0;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid var(--ops-border-strong);
  background: linear-gradient(90deg, rgba(15, 21, 18, 0.035) 1px, transparent 1px), #ffffff;
  background-size: 26px 26px;
}

.ai-viewer-strip {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  flex: 0 0 auto;
  align-items: center;
  gap: 12px;
  min-height: 64px;
  border-bottom: 1px solid var(--ops-border);
  padding: 0 18px;
}

.ai-theater-shell .viewer-title h2 {
  margin-top: 0;
  color: var(--ops-heading);
  font-size: 21px;
  font-weight: 900;
  line-height: 1.2;
}

.ai-theater-viewer {
  flex: 1 1 auto;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  min-height: 0;
  border-bottom: 1px solid var(--ops-border-strong);
  padding: 0;
}

.ai-theater-viewer .viewer-pane {
  min-height: 0;
  border: 0;
  border-right: 1px solid var(--ops-border);
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.ai-theater-viewer .viewer-pane:last-child {
  border-right: 0;
}

.ai-theater-viewer .viewer-pane figcaption {
  min-height: 46px;
  border-bottom: 1px solid var(--ops-border);
  background: rgba(246, 248, 247, 0.86);
  padding: 0 14px;
}

.ai-theater-viewer .ai-review-photo {
  height: 100%;
  min-height: 0;
  border-radius: 0;
}

.ai-decision-runway {
  display: grid;
  grid-template-columns: minmax(180px, 0.8fr) minmax(360px, 1.4fr) minmax(220px, 0.9fr) minmax(190px, 0.7fr);
  flex: 0 0 auto;
  gap: 0;
  border-bottom: 1px solid var(--ops-border-strong);
  background: #f8faf9;
}

.ai-decision-runway > * {
  min-width: 0;
  border-right: 1px solid var(--ops-border);
  padding: 14px;
}

.ai-decision-runway > *:last-child {
  border-right: 0;
}

.ai-decision-runway .decision-core {
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.ai-decision-runway .decision-core h2 {
  margin-top: 6px;
  color: var(--ops-heading);
  font-size: 22px;
  font-weight: 900;
}

.ai-decision-runway .primary-decision-actions {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.ai-decision-runway .decision-action {
  min-height: 74px;
  border-radius: 0;
}

.ai-decision-runway .decision-memo {
  display: grid;
  gap: 7px;
}

.ai-decision-runway .decision-memo textarea {
  min-height: 78px;
}

.ai-decision-runway .decision-next {
  display: grid;
  align-content: center;
  gap: 8px;
  border-radius: 0;
}

.ai-evidence-drawer {
  margin-top: auto;
  background: #ffffff;
}

.ai-evidence-drawer summary {
  display: flex;
  min-height: 44px;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--ops-border);
  padding: 0 18px;
}

.ai-evidence-drawer summary span,
.ai-evidence-drawer summary strong {
  font-size: 12px;
  font-weight: 900;
}

.ai-queue-column {
  display: flex;
  min-width: 0;
  min-height: 0;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  background: #f6f8f7;
}

.ai-queue-column .queue-head {
  min-height: 64px;
  border-bottom: 1px solid var(--ops-border);
  padding: 12px;
}

.queue-head-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
}

.queue-back-button {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ops-border);
  border-radius: 999px;
  background: #ffffff;
  color: var(--ops-heading);
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
}

.queue-back-button:hover {
  border-color: #111714;
  background: #111714;
  color: #ffffff;
}

.ai-queue-column .candidate-list {
  display: grid;
  min-height: 0;
  flex: 1 1 0;
  align-content: start;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
}

.ai-queue-column .candidate-row {
  min-height: 80px;
  border: 0;
  border-bottom: 1px solid var(--ops-border);
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  padding: 10px 12px;
}

.ai-queue-column .candidate-row.is-selected {
  background: #111714;
  color: #ffffff;
  box-shadow: none;
}

.ai-queue-column .candidate-row.is-selected strong,
.ai-queue-column .candidate-row.is-selected em,
.ai-queue-column .candidate-row.is-selected small {
  color: #ffffff;
}

.ai-queue-column .queue-metrics {
  border-top: 1px solid var(--ops-border-strong);
  padding: 10px;
}

.ai-queue-column .queue-metric {
  border-radius: 0;
  box-shadow: none;
}

@media (max-width: 1260px) {
  .ai-theater-grid,
  .ai-decision-runway {
    grid-template-columns: 1fr;
  }
  .ai-theater-grid {
    height: auto;
    min-height: 0;
    overflow: visible;
  }
  .ai-comparison-deck,
  .ai-decision-runway > * {
    border-right: 0;
  }
  .ai-comparison-deck {
    height: auto;
    overflow: visible;
  }
  .ai-theater-viewer .ai-review-photo {
    height: min(52vh, 430px);
    min-height: 320px;
  }
  .ai-queue-column {
    height: auto;
    max-height: 460px;
    border-top: 1px solid var(--ops-border-strong);
  }
}
@media (max-width: 760px) {
  .ai-theater-shell {
    padding: 12px;
  }
  .ai-review-list-head {
    min-height: 66px;
    padding: 0 12px;
  }
  .ai-review-list-head h1 {
    font-size: 19px;
  }
  .ai-review-run-row {
    grid-template-columns: minmax(84px, auto) minmax(0, 1fr);
    gap: 8px 10px;
    padding: 12px;
  }
  .run-guidance {
    min-width: 80px;
    min-height: 30px;
  }
  .run-meta {
    grid-column: 2;
    grid-template-columns: auto auto;
    justify-content: start;
    justify-items: start;
    gap: 8px;
  }
  .ai-queue-column {
    max-height: 360px;
  }
  .ai-theater-viewer .ai-review-photo {
    height: 340px;
    min-height: 300px;
  }
  .ai-viewer-strip,
  .ai-theater-viewer {
    grid-template-columns: 1fr;
  }
  .ai-theater-viewer .viewer-pane {
    border-right: 0;
    border-bottom: 1px solid var(--ops-border);
  }
  .ai-decision-runway .primary-decision-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}`],
})
export class PageAiReviewComponent implements OnInit {
    public selectedCaseCode: string = '';
    public selectedScopeKey: string = '';
    public allCases: any[] = [];
    public cases: any[] = [];
    public loadMessage: string = '';
    public decisionNotice: string = '';

    public actions: any[] = [
        { short: '이상 없음', label: '이상 없음 종결', description: '변화 없음으로 기록', status: 'FALSE_POSITIVE', result: workflowStatusLabel('report'), timeline: '변화 없음으로 확인해 보고서 작성 필요 상태로 기록했습니다.', tone: 'is-false-positive' },
        { short: '재촬영', label: '재촬영 요청', description: '동일 조건 촬영 재요청', status: 'RECAPTURE_REQUESTED', result: '재촬영 요청', timeline: '동일 조건 재촬영 요청으로 기록했습니다.', tone: 'is-recapture' },
        { short: '현장 확인', label: '현장 확인 필요', description: '현장 확인 대상으로 배정', status: 'FIELD_CHECK_REQUIRED', result: '현장 확인 필요', timeline: '현장 확인 필요 항목으로 기록했습니다.', tone: 'is-field-check' },
        { short: '결과 반영', label: 'AI 확인 결과 반영', description: '확인 결과를 보고서에 반영', status: 'CLOSED', result: workflowStatusLabel('report'), timeline: '확인 결과를 보고서 작성 필요 상태로 기록했습니다.', tone: 'is-closed' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.service.auth.allow('/access');
        await this.loadCases();
    }

    public async loadCases() {
        this.loadMessage = '';
        try {
            const response: any = await wiz.call('load', {}, { timeout: 15000 });
            const { code, data } = response || {};
            if (code === 200 && data) {
                this.allCases = (data.cases || []).map((item) => this.normalizeCase(item));
                this.syncSelectedScope();
            } else {
                this.loadMessage = (data && data.message) || 'AI 확인 대상을 불러오지 못했습니다.';
            }
        } catch (error) {
            this.loadMessage = 'AI 확인 대상을 불러오는 중 오류가 발생했습니다.';
            this.allCases = [];
            this.cases = [];
            this.selectedScopeKey = '';
            this.selectedCaseCode = '';
        }
        await this.service.render();
    }

    public get selectedCase() {
        return this.cases.find((item) => item.code === this.selectedCaseCode) || null;
    }

    public get scopeOptions() {
        const scopes: any[] = [];
        const index: any = {};
        (this.allCases || []).forEach((item) => {
            const key = this.caseScopeKey(item);
            if (!index[key]) {
                index[key] = {
                    key: key,
                    label: this.caseScopeLabel(item),
                    summary: this.caseTitle(item),
                    meta: this.caseScopeMeta(item),
                    workState: this.workState(item),
                    workStatePriority: 0,
                    completed: false,
                    count: 0,
                    openCount: 0
                };
                scopes.push(index[key]);
            }
            index[key].count += 1;
            const state = this.workState(item);
            if (state.priority > index[key].workStatePriority) {
                index[key].workState = state;
                index[key].workStatePriority = state.priority;
            }
            if (this.isPatrolCompletionCase(item)) index[key].completed = true;
            if (this.isPendingReview(item)) index[key].openCount += 1;
        });
        return scopes;
    }

    public get patrolScopeOptions() {
        const completed = this.scopeOptions.filter((item) => item.completed);
        return completed.length ? completed : this.scopeOptions;
    }

    public get allOpenCaseCount() {
        return (this.allCases || []).filter((item) => this.isPendingReview(item)).length;
    }

    public get selectedScopeOption() {
        return this.scopeOptions.find((item) => item.key === this.selectedScopeKey) || this.scopeOptions[0] || null;
    }

    public get selectedScopeLabel() {
        const scope = this.selectedScopeOption;
        return scope ? scope.label : '대기 중';
    }

    public scopeButtonTitle(scope: any) {
        if (!scope) return '';
        return `${scope.label} ${this.scopeWorkStateLabel(scope)} · 확인 목록 ${scope.openCount}/${scope.count}`;
    }

    private reviewRequestParams() {
        const query = new URLSearchParams((window && window.location && window.location.search) || '');
        return {
            scopeKey: query.get('scope') || '',
            caseCode: query.get('case') || query.get('code') || '',
            mission: query.get('mission') || '',
            missionCode: query.get('missionCode') || '',
            templateId: query.get('templateId') || '',
            runId: query.get('runId') || ''
        };
    }

    private hasReviewRequest(params: any) {
        return !!(params && (params.scopeKey || params.caseCode || params.mission || params.missionCode || params.templateId || params.runId));
    }

    private normalizeMissionToken(value: any) {
        return String(value || '').trim().replace(/^MIS-/, '');
    }

    private matchesReviewRequest(item: any, params: any) {
        if (!item || !params) return false;
        const requestedMission = String(params.mission || '').trim();
        const requestedMissionToken = this.normalizeMissionToken(requestedMission);
        const missionCode = String(item.missionCode || '').trim();
        return !!(
            (params.scopeKey && this.caseScopeKey(item) === String(params.scopeKey).trim())
            || (params.caseCode && String(item.code || '').trim() === String(params.caseCode).trim())
            || (params.runId && String(item.runId || '').trim() === String(params.runId).trim())
            || (params.templateId && String(item.templateId || '').trim() === String(params.templateId).trim())
            || (params.missionCode && missionCode === String(params.missionCode).trim())
            || (requestedMission && String(item.code || '').trim() === requestedMission)
            || (requestedMissionToken && this.normalizeMissionToken(missionCode) === requestedMissionToken)
        );
    }

    private caseScopeKey(item: any) {
        const runId = String(item && item.runId || '').trim();
        if (runId) return `run:${runId}`;
        const templateId = String(item && item.templateId || '').trim();
        if (templateId) return `template:${templateId}`;
        const missionCode = String(item && item.missionCode || '').trim();
        if (missionCode) return `mission:${missionCode}`;
        return `case:${String(item && item.code || 'default')}`;
    }

    private caseScopeLabel(item: any) {
        const village = this.userText(item && item.village, '').trim();
        if (village) return village;
        const title = this.userText(item && item.title, '').trim();
        return title || '순찰 기준';
    }

    private caseScopeMeta(item: any) {
        if (item && item.runId) return '순찰 완료';
        if (this.isPatrolCompletionCase(item)) return '촬영 결과';
        return workflowStatusLabel('ai');
    }

    private isPatrolCompletionCase(item: any) {
        const source = String(item && item.source || '').toLowerCase();
        return !!(
            item && (
                item.runId
                || source === 'mission'
                || source.indexOf('change') >= 0
                || source.indexOf('candidate') >= 0
                || item.visual
                || item.candidateBox
            )
        );
    }

    private applySelectedScope(preferredCaseCode: string = '') {
        this.cases = (this.allCases || []).filter((item) => this.caseScopeKey(item) === this.selectedScopeKey);
        const preferred = preferredCaseCode ? this.cases.find((item) => item.code === preferredCaseCode) : null;
        if (preferred) {
            this.selectedCaseCode = preferred.code;
        } else if (!this.cases.find((item) => item.code === this.selectedCaseCode)) {
            this.selectedCaseCode = this.cases.length ? this.cases[0].code : '';
        }
    }

    private syncSelectedScope() {
        if (!this.allCases.length) {
            this.cases = [];
            this.selectedScopeKey = '';
            this.selectedCaseCode = '';
            return;
        }

        const params = this.reviewRequestParams();
        const requestedCase = this.hasReviewRequest(params)
            ? this.allCases.find((item) => this.matchesReviewRequest(item, params))
            : null;
        if (requestedCase) {
            this.selectedScopeKey = this.caseScopeKey(requestedCase);
            this.applySelectedScope(requestedCase.code);
            return;
        }

        if (this.selectedScopeKey && this.allCases.find((item) => this.caseScopeKey(item) === this.selectedScopeKey)) {
            this.applySelectedScope(this.selectedCaseCode);
            return;
        }

        this.cases = [];
        this.selectedScopeKey = '';
        this.selectedCaseCode = '';
    }

    private updateReviewRequestQuery(scopeKey: string = '') {
        try {
            if (typeof window === 'undefined' || !window.history || !window.location) return;
            const url = new URL(window.location.href);
            ['scope', 'case', 'code', 'mission', 'missionCode', 'templateId', 'runId'].forEach((key) => url.searchParams.delete(key));
            if (scopeKey) {
                const scopeCase = this.allCases.find((item) => this.caseScopeKey(item) === scopeKey);
                url.searchParams.set('scope', scopeKey);
                if (scopeCase && scopeCase.runId) url.searchParams.set('runId', scopeCase.runId);
                if (scopeCase && scopeCase.missionCode) url.searchParams.set('missionCode', scopeCase.missionCode);
                if (scopeCase && scopeCase.templateId) url.searchParams.set('templateId', scopeCase.templateId);
            }
            window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        } catch (error) { }
    }

    public normalizeCase(item: any) {
        const sourceType = this.sourceKey(item);
        return {
            ...(item || {}),
            sourceType: sourceType,
            sourceLabel: this.sourceLabel({ sourceType: sourceType })
        };
    }

    private sourceKey(item: any) {
        const value = (item && (item.sourceType || item.scenarioType) || '').toString().toLowerCase();
        if (value === 'demo' || value === 'sample' || value === 'example' || value === 'default') return 'demo';
        return 'custom';
    }

    public sourceLabel(item: any) {
        return this.sourceKey(item) === 'demo' ? '운영 기준' : '확인 기준';
    }

    public sourceBadgeClass(item: any) {
        return this.sourceKey(item) === 'demo'
            ? 'is-operational-source'
            : 'is-registered-source';
    }

    public candidateSourceLabel(item: any) {
        return '변화 의심 위치';
    }

    public visualLabel(item: any, kind: string) {
        const visual = item && item.visual && item.visual[kind] ? item.visual[kind] : null;
        if (visual && visual.label) return visual.label;
        return kind === 'baseline' ? '기준 사진' : '현재 사진';
    }

    public caseTitle(item: any) {
        return this.userText(item && (item.title || item.candidateArea), '확인 대상');
    }

    public candidateAreaLabel(item: any) {
        return this.userText(item && item.candidateArea, '확인할 위치');
    }

    public decisionLabel(item: any) {
        const status = String(item && item.status || '').trim();
        if (status) return workflowStatusLabel(status);
        return this.userText(item && item.decision, workflowStatusLabel('ai'));
    }

    private sanitizeScoreText(text: string) {
        return String(text || '')
            .replace(/AI\s*참고\s*[:：]?\s*\d+\s*%?/gi, '확인 참고')
            .replace(/(위험도|신뢰도|점수)\s*[:：]?\s*\d+\s*%?/g, '')
            .replace(/\d+\s*점/g, '')
            .replace(/\d+\s*%/g, '')
            .replace(/\s*[·,/|-]\s*(?=\s*[·,/|-]|$)/g, ' ')
            .replace(/\s{2,}/g, ' ')
            .trim();
    }

    private userText(value: any, fallback: string) {
        const text = this.sanitizeScoreText(String(value || fallback).trim() || fallback);
        return (text || fallback)
            .replace(/AI\s*후\s*보/g, 'AI 확인 대상')
            .replace(/변화\s*후\s*보/g, '변화 의심')
            .replace(/후\s*보\s*영역/g, '확인할 위치')
            .replace(/확인\s*후\s*보/g, '확인 대상')
            .replace(/후\s*보/g, '확인 대상')
            .replace(/오탐 처리/g, '이상 없음 종결')
            .replace(/오탐/g, '이상 없음 종결')
            .replace(/변화 아님/g, '이상 없음 종결')
            .replace(/현장 확인 요청/g, '현장 확인 필요')
            .replace(/^현장 확인$/g, '현장 확인 필요')
            .replace(/^재촬영$/g, '재촬영 요청')
            .replace(/검토 대기/g, workflowStatusLabel('ai'))
            .replace(/확인 대기/g, workflowStatusLabel('ai'))
            .replace(/담당자 확인 필요/g, workflowStatusLabel('ai'))
            .replace(/보고 반영/g, workflowStatusLabel('report'))
            .replace(/처리 완료/g, workflowStatusLabel('report'))
            .replace(/이상 없음 종결/g, workflowStatusLabel('report'))
            .replace(/^종결$/g, workflowStatusLabel('report'))
            .replace(/판정/g, '확인 결과');
    }

    public visualStyle(item: any, kind: string) {
        const visual = item && item.visual && item.visual[kind] ? item.visual[kind] : {};
        return {
            background: visual.background || 'linear-gradient(135deg, #d9e6d6 0%, #eef2e8 42%, #c7d2c2 43%, #e7e1d2 100%)'
        };
    }

    public terrainClass(item: any) {
        const visualTerrain = item && item.visual && item.visual.terrain ? String(item.visual.terrain) : '';
        const village = item && item.village ? String(item.village) : '';
        if (visualTerrain) return `terrain-${visualTerrain}`;
        if (village.indexOf('삼가') >= 0) return 'terrain-samgari';
        if (village.indexOf('법주사') >= 0) return 'terrain-beopjusa';
        return 'terrain-saneri';
    }

    public photoClass(item: any, kind: string) {
        return {
            [this.terrainClass(item)]: true,
            'is-baseline': kind === 'baseline',
            'is-current': kind === 'current'
        };
    }

    public flightMeta(item: any) {
        const meta = item && item.visual && item.visual.meta ? String(item.visual.meta) : '';
        return this.readableFlightMeta(meta);
    }

    private readableFlightMeta(meta: string) {
        const value = (meta || '').trim();
        if (!value || value === 'ALT 기준값 · 동일 구도') return '기준과 같은 촬영 조건';

        const labels: any = {
            ALT: '고도',
            HDG: '방향',
            GMB: '카메라 각도'
        };
        const parts = value.split('·').map((part) => {
            const text = part.trim().replace(/\s+/g, ' ');
            const match = text.match(/^(ALT|HDG|GMB)\s*(.+)$/i);
            if (!match) return text;
            const key = match[1].toUpperCase();
            return `${labels[key] || key} ${match[2]}`;
        }).filter(Boolean);

        return parts.length ? parts.join(' · ') : '기준과 같은 촬영 조건';
    }

    public candidateBoxStyle(item: any) {
        const box = item && item.candidateBox ? item.candidateBox : {};
        return {
            left: `${Number(box.x || 48)}%`,
            top: `${Number(box.y || 42)}%`,
            width: `${Number(box.w || 22)}%`,
            height: `${Number(box.h || 18)}%`
        };
    }

    public candidateBoxClass(item: any) {
        const box = item && item.candidateBox ? item.candidateBox : {};
        const labelSide = box.labelSide || 'right';
        return {
            'candidate-label-left': labelSide === 'left',
            'candidate-label-above': labelSide === 'above'
        };
    }

    public isPendingReview(item: any) {
        return item && item.status === 'UNDER_REVIEW';
    }

    public get openCaseCount() {
        return this.cases.filter((item) => this.isPendingReview(item)).length;
    }

    public get nextPendingCase() {
        if (!this.cases.length) return null;
        const selectedIndex = Math.max(0, this.cases.findIndex((item) => item.code === this.selectedCaseCode));
        for (let offset = 1; offset <= this.cases.length; offset++) {
            const candidate = this.cases[(selectedIndex + offset) % this.cases.length];
            if (candidate && candidate.code !== this.selectedCaseCode && this.isPendingReview(candidate)) return candidate;
        }
        return null;
    }

    public get reviewMetrics() {
        const waiting = this.cases.filter((item) => item.status === 'UNDER_REVIEW').length;
        const requested = this.cases.filter((item) => item.status === 'RECAPTURE_REQUESTED').length;
        const field = this.cases.filter((item) => item.status === 'FIELD_CHECK_REQUIRED').length;
        const closed = this.cases.filter((item) => item.status === 'CLOSED' || item.status === 'FALSE_POSITIVE').length;
        return [
            { label: workflowStatusLabel('ai'), value: `${waiting}건`, tone: workflowStatusCssClass('ai') },
            { label: workflowStatusLabel('recapture'), value: `${requested}건`, tone: workflowStatusCssClass('recapture') },
            { label: workflowStatusLabel('field'), value: `${field}건`, tone: workflowStatusCssClass('field') },
            { label: workflowStatusLabel('report'), value: `${closed}건`, tone: workflowStatusCssClass('report') }
        ];
    }

    public decisionActionClass(action: any, item: any) {
        const classes = [action.tone || ''];
        if (item && item.lastAction === action.status) classes.push('is-active');
        return classes.join(' ').trim();
    }

    public async selectCase(code: string) {
        this.selectedCaseCode = code;
        this.decisionNotice = '';
        await this.service.render();
    }

    public async selectScope(key: string) {
        if (!key || key === this.selectedScopeKey) return;
        this.selectedScopeKey = key;
        this.decisionNotice = '';
        this.applySelectedScope('');
        this.updateReviewRequestQuery(key);
        await this.service.render();
    }

    public async backToScopeList() {
        this.selectedScopeKey = '';
        this.selectedCaseCode = '';
        this.cases = [];
        this.decisionNotice = '';
        this.updateReviewRequestQuery('');
        await this.service.render();
    }

    public async moveToNextCandidate() {
        const next = this.nextPendingCase;
        if (!next) return;
        this.selectedCaseCode = next.code;
        this.decisionNotice = '';
        await this.service.render();
    }

    public async updateMemo(event: any) {
        if (!this.selectedCase) return;
        const target = event.target as HTMLTextAreaElement;
        this.selectedCase.memo = target.value;
        await this.service.render();
    }

    public async applyAction(action: any) {
        const item = this.selectedCase;
        if (!item) return;
        item.status = action.status;
        item.lastAction = action.status;
        item.decision = action.result;
        item.timeline = [
            { time: this.nowLabel(), title: action.label, body: action.timeline },
            ...(item.timeline || [])
        ];
        this.decisionNotice = `${action.result} 상태로 반영 중입니다.`;
        await this.service.render();
        try {
            const response: any = await wiz.call('load', {
                action: 'update_case',
                case: JSON.stringify(item)
            }, { timeout: 15000 });
            const { code, data } = response || {};
            if (code === 200 && data && data.updated !== false) {
                this.loadMessage = '';
                this.decisionNotice = `${action.result} 상태로 반영되었습니다. 다음 확인 대상으로 이동할 수 있습니다.`;
                const updatedCase = data.case || null;
                if (updatedCase) {
                    const normalized = this.normalizeCase(updatedCase);
                    const allIndex = this.allCases.findIndex((candidate) => candidate.code === normalized.code);
                    if (allIndex >= 0) this.allCases[allIndex] = normalized;
                    const index = this.cases.findIndex((candidate) => candidate.code === normalized.code);
                    if (index >= 0) this.cases[index] = normalized;
                }
            } else if (code === 200 && data && data.updated === false) {
                this.loadMessage = 'AI 확인 결과가 반영되었습니다. 결과 동기화 상태를 확인 중입니다.';
                this.decisionNotice = `${action.result} 상태가 화면에 반영되었습니다.`;
            } else {
                this.loadMessage = (data && data.message) || 'AI 확인 결과 반영에 실패했습니다.';
                this.decisionNotice = `${action.result} 상태가 화면에 반영되었습니다.`;
            }
        } catch (error) {
            this.loadMessage = 'AI 확인 결과 반영 중 오류가 발생했습니다.';
            this.decisionNotice = `${action.result} 상태가 화면에 반영되었습니다.`;
        }
        await this.service.render();
    }

    public nowLabel() {
        const now = new Date();
        const hour = String(now.getHours()).padStart(2, '0');
        const minute = String(now.getMinutes()).padStart(2, '0');
        return `${hour}:${minute}`;
    }

    public statusClass(status: string) {
        return workflowStatusCssClass(status || 'ai');
    }

    private workState(item: any) {
        const status = String(item && item.status || '').trim();
        const decision = this.userText(item && item.decision, '').trim();
        if (status === 'FIELD_CHECK_REQUIRED' || decision.indexOf('현장 확인') >= 0) {
            return { label: workflowStatusLabel('field'), tone: workflowStatusCssClass('field'), priority: workflowStatus('field').priority };
        }
        if (status === 'RECAPTURE_REQUESTED' || decision.indexOf('재촬영') >= 0 || decision.indexOf('재확인') >= 0) {
            return { label: workflowStatusLabel('recapture'), tone: workflowStatusCssClass('recapture'), priority: workflowStatus('recapture').priority };
        }
        if (status === 'CLOSED' || status === 'FALSE_POSITIVE' || decision.indexOf('보고') >= 0 || decision.indexOf(workflowStatusLabel('report')) >= 0) {
            return { label: workflowStatusLabel('report'), tone: workflowStatusCssClass('report'), priority: workflowStatus('report').priority };
        }

        const priority = Number(item && item.risk || 0);
        if (priority >= 80) return { label: workflowStatusLabel('field'), tone: workflowStatusCssClass('field'), priority: workflowStatus('field').priority };
        if (priority >= 70) return { label: workflowStatusLabel('recapture'), tone: workflowStatusCssClass('recapture'), priority: workflowStatus('recapture').priority };
        return { label: workflowStatusLabel('ai'), tone: workflowStatusCssClass('ai'), priority: workflowStatus('ai').priority };
    }

    public workStateLabel(item: any) {
        return this.workState(item).label;
    }

    public workStateClass(item: any) {
        return this.workState(item).tone;
    }

    public scopeWorkStateLabel(scope: any) {
        return scope && scope.workState ? scope.workState.label : workflowStatusLabel('ai');
    }

    public scopeWorkStateClass(scope: any) {
        return scope && scope.workState ? scope.workState.tone : workflowStatusCssClass('ai');
    }
}

export default PageAiReviewComponent;